import Vue from 'vue';
import Router from 'vue-router';
import Home from './view/home';
import BbsLayout from '@/layout/BbsLayout';


Vue.use(Router);

const routes = [
	{
		path: '/bbs',
		component: BbsLayout,
		redirect: '/bbs/index',
		children: [
			{
				path: 'index',
				component: () => import('./view/bbs/index.vue'),
				name: 'bbsIndex',
			},
			{
				path: 'create',
				name: 'CreatePost',
				component: () => import('./view/bbs/CreatePost.vue'),
			},
		]
	},
	{
		path: '/post/:id',
		component: BbsLayout,
		children: [
			{
				path: '',
				component: () => import('./view/bbs/PostDetail.vue'),
				name: 'PostDetail',
			}
		]
	},

	{
		path: '/',
		component: Home,
		meta: {},
		children: [
			{
				path: '',
				name: 'index',
				component: () => import('./view/index'),
				meta: {
					title: '首页'
				}
			},
			{
				path: 'pay',
				name: 'pay',
				component: () => import('./view/pay'),
				meta: {
					title: '支付'
				}
			},
			{
				path: 'result',
				name: 'result',
				component: () => import('./view/pay/result'),
				meta: {
					title: '支付结果'
				}
			},
			{
				path: 'ai',
				name: 'ai',
				component: () => import('./view/ai'),
				meta: {
					title: '问答'
				}
			},
			{
				path: 'agreement',
				name: 'agreement',
				component: () => import('./view/agreement'),
				meta: {
					title: '用户协议'
				}
			},
			{
				path: 'privacy',
				name: 'privacy',
				component: () => import('./view/privacy'),
				meta: {
					title: '隐私政策'
				}
			}, {
				path: 'order',
				name: 'order',
				meta: {
					title: '个人订单',
					name: '个人订单',
				},
				component: () => import('@/view/mine/order'),
			},

			{
				path: 'order/level',
				name: 'orderLevel',
				meta: {
					title: '个人订单',
					name: '个人订单',
				},
				redirect: { name: 'order' },
				component: () => import('@/view/mine'),
				children: [
					{
						path: 'startupDetail',
						name: 'startupDetail',
						meta: {
							title: '详情',
							name: '个人订单',
						},
						component: () => import('@/view/mine/order/detail'),
					},
				],
			},
			{
				path: 'setting',
				name: 'setting',
				meta: {
					title: '账户中心',
					name: '账户中心',
				},
				component: () => import('@/view/mine/setting'),
			},
			// {
			// 	path: 'test',
			// 	name: 'test',
			// 	component: () => import('./view/test'),
			// 	meta: {
			// 		title: '测试'
			// 	}
			// },
			// {
			// 	path: 'test1',
			// 	name: 'test1',
			// 	component: () => import('./view/test/guide1'),
			// 	meta: {
			// 		title: '测试1'
			// 	}
			// },
			// {
			// 	path: 'test2',
			// 	name: 'test2',
			// 	component: () => import('./view/test/guide2'),
			// 	meta: {
			// 		title: '测试2'
			// 	}
			// },
			{
				path: 'zsk',
				name: 'zsk',
				component: () => import('./view/zsk'),
				meta: {
					title: '知识库'
				}
			},
			{
				path: 'forum',
				name: 'forum',
				component: () => import('./view/forum'),
				meta: {
					title: '论坛'
				}
			},
			{
				path: 'about',
				name: 'about',
				component: () => import('./view/about'),
				meta: {
					title: '关于我们'
				}
			},
			{
				path: 'school',
				name: 'school',
				component: () => import('./view/School/School.vue'),
				meta: {
					title: '培训课程'
				}
			},
			{
				path: 'course',
				name: 'course',
				component: () => import('./view/Course/Course.vue'),
				meta: {
					title: '培训课程'
				}
			},
			{
				path: 'video',
				name: 'video',
				component: () => import('./view/Course/Video.vue'),
				meta: {
					title: '培训课程视频'
				}
			},
{
				path: 'guide',
				name: 'guide',
				component: () => import('./view/Guide/Guide.vue'),
				meta: {
					title: '专业统计服务交付中心'
				}
			},


		]
	}
];

// add route path
routes.forEach(route => {
	route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
	mode: 'history',
	scrollBehavior: () => ({ x: 0, y: 0 }),
	routes
});

// 捕获重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
	const title = to.meta && to.meta.title;
	if (title) {
		// document.title = title + '_报表智能体_beta版';
		// document.title = '报表智能体_beta.1';
	}

	next();
});

export default router;